<template>
  <div class="login">
    <div :class="isHD?'login_content login_content_hd':'login_content'">
      <!--<div class="login_content_header">
        <img src="../../static/images/logo2.png"/>
        <p>镜界眼镜店管理系统</p>
      </div>-->
      <div class="login_download" @click="downloadFn">下载中心</div>
      <div :class="isHD?'login_content_login_hd':'login_content_login'">
        <div :class="isHD?'login_wrap login_wrap_hd':'login_wrap'">
          <h2>{{ shopName || title }}</h2>
          <div class="box_switch" v-if="isHD">
            <ul class="box_title">
              <li :class="indexbox == 3?'clothing2 active':'clothing'" @click="boxSwitch(3, 36)" v-if="!isApparatusV">服装</li>
              <li :class="indexbox == 2?'medicalCare2 active':'medicalCare'" @click="boxSwitch(2, 37)" v-if="!isApparatusV">医药</li>
              <li :class="indexbox == 1?'medicalCare2 active':'medicalCare'" @click="boxSwitch(1, 38)">医疗器械</li>
            </ul>
          </div>
          <div v-if="isPC" class="login_wrap_input">
            <el-input type="phone" v-model="shopCode" placeholder="门店编号" @focus="focus($event)" clearable>
              <template slot="prepend"><i class="el-icon-s-shop"></i></template>
            </el-input>
          </div>
          <div class="login_wrap_input">
            <el-input type="phone" v-model="telephone" :placeholder="isPC?'手机号或员工编号':'手机号'" @focus="focus($event)" clearable>
              <template slot="prepend"><i class="el-icon-mobile-phone"></i></template>
            </el-input>
          </div>
          <div class="login_wrap_input">
            <el-input type="password" v-model="password" placeholder="登录密码" @focus="focus($event)" @keydown.enter.native.stop="loginFn" clearable>
              <template slot="prepend"><i class="el-icon-lock"></i></template>
            </el-input>
          </div>
          <div class="login_wrap_item">
            <div>
              <el-checkbox v-model="rememberPassword">记住密码</el-checkbox>
            </div>
            <h6 v-if="isHD" style="color: #f5711d; margin-right: 30px;" @click="testLoginFn">游客登录</h6>
            <h6 v-if="isHD" @click="registeredFn">账户注册</h6>
            <h6 @click="forgotPasswordFn">忘记密码?</h6>
          </div>
          <div class="login_wrap_btn" style="position: relative">
            <h3 @click="loginFn">登录</h3>
            <h3 @click="outFn" v-if="isPCShow">退出</h3>
            <div v-if="!isHD && !isPC" class="login_wrap_tips">
              <span>服务热线：</span>
              <span style="padding-right: 10px;">0393-8591654</span>
              <span>13461625846</span>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!--<div class="login_content_bottom">
      <h6>深圳市海德领航科技有限公司</h6>
      <a href="https://beian.miit.gov.cn" target="_blank">© Copyright Lichu 2014-2021 粤ICP备17125537号</a>
      <a href="https://beian.miit.gov.cn" target="_blank">粤ICP备17125537号</a>
    </div>-->

    <el-dialog title="登陆门店选择" :visible.sync="shopShow" top="0" class="window_wrap" width="400px"
    :modal=false v-dialogDrag :closeOnClickModal=false :show-close=false>
      <div class="window_content">
        <div class="window_list" v-for="(i, index) in shopList" @click="jumpFn(i)" :title="i.name">
          <div class="window_list_img">
            <img :src="i.logo ? imgUrl + i.logo : '../../static/images/picture.png'" alt="LOGO"/>
          </div>
          <div class="window_list_name">{{ i.name }}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import qs from 'qs';
  import md5 from 'js-md5';
  import {interfaceFn, timeFn, getVersionType, encryption, decrypt
  , isPC, saveGlassesFlag, isGlasses, pconlineFn, isApparatusVFn} from "@/assets/util";

  export default {
    data() {
      return {
        msg: '',
        title: '',
        shopName: '',
        shopCode: '',
        isPC: isPC(),
        isHD: window.localStorage.getItem("isHD"),
        rememberPassword: false,
        loginData: {user: {}},
        telephone: '',
        versionType: 36,
        password: '',
        shopList: [],
        shopShow: false,
        imgUrl: interfaceFn(),
        isPCShow: isPC(),
        isApparatusV: isApparatusVFn(),
        indexbox: 1,
      }
    },

    created() {
      this.init();
    },

    mounted() {},
    methods: {
      init() {
        if(isGlasses()){
          let isBillingDate = window.localStorage.getItem("isBillingDate");
          if(isBillingDate == null){
            window.localStorage.setItem("isBillingDate", 'true');
          }
        }
        this.shopName = "";
        if (isPC()) {
          let loginShop = window.localStorage.getItem('loginShop');
          if (loginShop) {
            try {
              loginShop = JSON.parse(loginShop);
              this.shopName = loginShop.name || '';
              this.shopCode = loginShop.code || '';
            } catch (e) {
            }
          }
        }
        this.versionType = getVersionType();
        if (!this.versionType) {
          this.versionType = 36;
        }

        if (window.location.host.indexOf("eye.") > 0) {
          this.versionType = 35;
        }
        this.versionType = parseInt(this.versionType);
        switch (this.versionType) {
          case 36:
            this.indexbox = 3;
            break;
          case 37:
            this.indexbox = 2;
            break;
          case 38:
            this.indexbox = 1;
            break;
          case 35:
            break;
          default:
            this.indexbox = 3;
        }
        if (isApparatusVFn() && window.location.host.indexOf("zmd.") != -1) {
          this.indexbox = 1;
          this.versionType = 38;
          localStorage.setItem("versionType", 38);
        }
        this.title = isPC() ? "登录" : "登录后台管理";
        let loginInfo = window.localStorage.getItem('loginInfo');
        if (loginInfo) {
          loginInfo = JSON.parse(loginInfo);
          if (loginInfo.shopCode) this.shopCode = loginInfo.shopCode;
          this.telephone = loginInfo.telephone;
          this.rememberPassword = loginInfo.rememberPassword == true;
          this.password = loginInfo.password && this.rememberPassword ? decrypt(decrypt(loginInfo.password)) : '';
        }
      },

      focus(event) {
        event.currentTarget.select();
      },

      boxSwitch(n, versionType) {
        this.indexbox = n;
        this.versionType = versionType;
        window.localStorage.setItem("versionType", this.versionType);
      },

      downloadFn() {
        let routeUrl = this.$router.resolve({
          path: "/download",
//					query: { id: 1 }
        });
        window.open(routeUrl.href, '_blank');
      },

      // 登录
      loginFn() {
        this.telephone = this.telephone ? this.telephone.trim() : '';
        if (!this.telephone) {
          this.msgFn('warning', this.isPC ? '登录手机号或员工编号不能为空' : '登录手机号不能为空');
          return;
        }
        if (!this.shopCode && !(/^1[1-9]\d{9}$/.test(this.telephone))) {
          this.msgFn('warning', '请输入正确的手机号');
          return;
        }
        if (this.shopCode && (!this.telephone)) {
          this.msgFn('warning', '请输入正确的手机号或员工编号');
          return;
        }
        this.password = this.password ? this.password.trim() : '';
        if (!this.password) {
          this.msgFn('warning', '登录密码不能为空');
          return;
        }

        let data = {
          telephone: this.telephone,
          versionType: this.versionType,
          password: md5(this.password)
        }
        // window.localStorage.setItem('indexbox',this.indexbox);
        // 设置登入版本
        this.$store.state.indexBox = this.indexbox;

        let loginInfo = {
          // shopCode: this.shopCode,
          telephone: this.telephone,
          rememberPassword: this.rememberPassword,
          password: this.rememberPassword ? encryption(encryption(this.password)) : ''
        }
        if (this.shopCode) loginInfo.shopCode = this.shopCode;
        window.localStorage.setItem('loginInfo', JSON.stringify(loginInfo))
        let info = {
          telephone: data.telephone,
          versionType: this.versionType,
          password: data.password,
        }
        if (this.shopCode && isPC()) info.shopCode = this.shopCode;
        let loadingInstance = this.$loading({fullscreen: true});
        this.$api.login(info).then((res) => {
          loadingInstance.close();
          if (res.data.code == 0) {
            let loginData = res.data.data;
            this.loginData = loginData;
            this.$store.state.merchantId = loginData.merchantId;
            this.getShopFn();
            this.getMerchantInfoFn();
          } else {
            this.msgFn('warning', res.data.message || '用户不存在');
          }
        }).catch(() => {
          loadingInstance.close();
        });
      },
      outFn() {
        window.close();
        return;
      },
      getMerchantInfoFn() {
        this.$http.get(interfaceFn() + '/merchant/new/getMerchantMsg').then((res) => {
          if (res.status == 200) {
            if (res.data.returnCode == 'ok') {
              let merchantInfo = res.data.data;
              if (merchantInfo) {
                saveGlassesFlag(merchantInfo.glassesFlag);
              }
            }
          }
        }).catch((e) => {
          console.log(e);
        });
      },
      // 获取门店
      getShopFn() {
        let loadingInstance = this.$loading({fullscreen: true});
        this.$http.get(interfaceFn() + '/shop/list?includeExpired=0&merchantId='
          + this.$store.state.merchantId).then((res) => {
          loadingInstance.close();
          if (res.status == 200) {
            let data = res.data;
            data = data.filter(f => f.status == 0);
            let list = [];
            if (this.loginData.user.identity == 1) {
              list = data;
            } else {
              let managementStore = JSON.parse(this.loginData.user.managementStore);
              if (!(Array.isArray(managementStore))) {
                managementStore = (managementStore + "").split(",");
              }
              managementStore.forEach(f => {
                data.forEach(k => {
                  if (f == k.id) list.push(k);
                })
              })
            }
            window.localStorage.removeItem('isPCType');
            this.shopList = list;
            if (list.length == 1) {
              this.jumpFn(list[0]);
            } else if (list.length > 1) {
              if (!isPC()) {
                let loginShop = window.localStorage.getItem('loginShop');
                if (loginShop) {
                  try {
                    loginShop = JSON.parse(loginShop);
                    let login = list.find(s => s.id == loginShop.id);
                    if (login) {
                      this.jumpFn(login);
                      return;
                    }
                  } catch (e) {
                    console.log(e);
                  }
                }
                let currShop = list.filter(f => f.id == this.loginData.shopId);
                if (currShop.length > 0) {
                  this.jumpFn(currShop[0]);
                } else {
                  this.jumpFn(list[0]);
                }
              } else {
                if (this.shopCode) {
                  let shop = list.find(s => s.code == this.shopCode);
                  if (shop) {
                    this.jumpFn(shop);
                    return;
                  }
                }
                this.shopShow = true;
              }
            } else if (list.length == 0 && isPC()) {//exe
              this.msgFn('warning', '管理门店已过期，请联系技术人员');
            } else {//pc
              window.localStorage.setItem('isPCType', false);
              this.jumpFn({
                name: '门店名称',
                logo: '',
                id: this.loginData.shopId
              });
            }
          }
        }).catch(() => {
          loadingInstance.close();
        });
      },
      // 门店选择-跳转
      jumpFn(i) {
        if (this.isPC) {
          this.$http.get(interfaceFn() + '/pconline/number?pcType=0&shopId=' + i.id).then((res) => {
            if (res.data.code == 0) {
              let data = res.data.data;
              if (data.pcNumber < data.onlineCount) {
                this.msgFn('warning', '已超过登录数，请查验后重新登录');
              } else {
                this.goHomeFn(i);
              }
            } else {
              this.msgFn('warning', res.data.message);
            }
          }).catch(() => {
            this.msgFn('error', '服务器错误');
          })
        } else {
          this.goHomeFn(i);
        }
      },
      goHomeFn (i) {
        let _this = this;
        let loadingInstance = this.$loading({fullscreen: true});
        this.shopShow = false;
        this.$store.state.isLogin = true;
        this.$store.state.loginExpired = false;
        this.loginData.shopInfo = i;
        this.$store.commit('setLoginInfo', this.loginData);
        this.msgFn('success', '验证成功');
        localStorage.setItem("loginShop", JSON.stringify(i));
        localStorage.setItem("shopId", this.loginData.shopId);
        localStorage.setItem("userId", this.loginData.userId);
        localStorage.setItem("userName", this.loginData.user.nickname);

        let loginInfo = localStorage.getItem('loginInfo');
        if (loginInfo && isPC()) {
          loginInfo = JSON.parse(loginInfo)
          if (!loginInfo.shopCode) {
            localStorage.setItem("loginInfo", JSON.stringify({
              ...loginInfo,
              shopCode: i.code
            }));
          }
        }

        setTimeout(() => {
          loadingInstance.close();
          this.$store.state.shopId = i.id;
          this.$store.state.loginOut = false;
          this.$router.push({path: '/home'});
          this.$api.initData(); // 初始化数据
          pconlineFn(_this, 0);
        }, 500);
      },

      // 前往注册页面
      registeredFn() {
        this.$router.push({path: '/registered'});
      },
      testLoginFn() {
        if (this.isApparatusV) this.versionType = 38;
        let data = {
          telephone: '8888',
          versionType: this.versionType,
          password: md5('8888')
        }
        // 设置登入版本
        this.$store.state.indexBox = this.indexbox;
        let info = {
          telephone: data.telephone,
          versionType: this.versionType,
          password: data.password,
        }
        switch (data.versionType) {
          case 36:
            info.shopCode = '';
            break;
          case 37:
            info.shopCode = '';
            break;
          case 38:
            info.shopCode = '';
            break;
          case 35:
            info.shopCode = '';
            break;
        }
        let loadingInstance = this.$loading({fullscreen: true});
        this.$api.login(info).then((res) => {
          loadingInstance.close();
          if (res.data.code == 0) {
            let loginData = res.data.data;
            this.loginData = loginData;
            this.$store.state.merchantId = loginData.merchantId;
            this.getShopFn();
            this.getMerchantInfoFn();
          } else {
            this.msgFn('warning', res.data.message || '用户不存在');
          }
        }).catch(() => {
          loadingInstance.close();
        });
      },
      // 找回密码
      forgotPasswordFn() {
        this.$router.push({path: '/forgotPassword'});
      },

      msgFn(type, msg) {
        this.$Message({
          duration: 2000,
          type: type,
          message: msg
        });
      },
    }
  }
</script>

<style scoped>
  @import url("../../static/css/login.css");
  .login_wrap_tips{
    position: absolute;
    color: red;
    top: 60px;
    left: -12px;
    width: 380px;
    text-align: center;
    font-weight: bold;
    font-size: 18px;
  }
  .login_wrap_tips span {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue